import { render, staticRenderFns } from "./SingleRep.vue?vue&type=template&id=1139b78a&scoped=true&"
import script from "./SingleRep.vue?vue&type=script&lang=ts&"
export * from "./SingleRep.vue?vue&type=script&lang=ts&"
import style0 from "./SingleRep.vue?vue&type=style&index=0&id=1139b78a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1139b78a",
  null
  
)

export default component.exports